export default "__VITE_ASSET__Cz0tITxo__"